import { boot } from 'quasar/wrappers';
import { Platform } from 'quasar';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue
} from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  storageBucket: process.env.FIREBASE_STORAGEBUCKET,
  projectId: process.env.FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.FIREBASE_MESSAGINGSENDERID,
  appId: process.env.FIREBASE_APPID,
  measurementId: process.env.FIREBASE_MEASUREMENTID
};
initializeApp(firebaseConfig);
const remoteConfig = getRemoteConfig();
remoteConfig.settings.minimumFetchIntervalMillis = 0;

const configInit = {
  realmId: process.env.REALM_PROJECT,
  dbName: process.env.DB_NAME,
  shareURL: process.env.VUE_APP_URL,
  build: '',
  version: '',
  device: 'Web'
};
remoteConfig.defaultConfig = configInit;

export default boot(async () => {
  try {
    await fetchAndActivate(remoteConfig);
    configInit.realmId =
      getValue(remoteConfig, 'realm_id').asString() || configInit.realmId;
    configInit.dbName =
      getValue(remoteConfig, 'db_name').asString() || configInit.dbName;
    configInit.shareURL =
      getValue(remoteConfig, 'share_url').asString() || configInit.shareURL;
  } catch (error) {
    console.log(error);
  }
  if (Platform.is.chrome) {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: process.env.FIREBASE_VAPIDKEY })
      .then(currentToken => {
        console.log(currentToken);
      })
      .catch(console.error);
  }
});

export const config = () => {
  return configInit;
};
